import React from "react";

import { useModal } from "../../hooks/useModal";
import { DeleteBillingModal } from "../DeleteBillingModal";
import { Icon, IconNameEnum, IconTypeEnum } from "../Icon";

interface ITableDeleteBillingCellProps {
  billingId: number;
  billingYear: number;
}

export const TableDeleteBillingCell: React.FC<ITableDeleteBillingCellProps> = ({ billingId, billingYear }) => {
  const { isModalVisible, toggleModalVisibility } = useModal();

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    toggleModalVisibility();
  };

  return (
    <>
      <Icon name={IconNameEnum.delete} type={IconTypeEnum.red} onClick={handleClick} />
      <DeleteBillingModal
        billingId={billingId}
        billingYear={billingYear}
        isModalVisible={isModalVisible}
        toggleModalVisibility={toggleModalVisibility}
      />
    </>
  );
};
